import { Button } from '@vallourec-ui/vallourec-ui'
import styled, { css } from 'styled-components'

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`

export const TitleContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;
  width: 40%;
`

export const ActionContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
`

export const SearchBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  margin: 0px 10px;
  width: 100%;
  position: relative;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  width: 100%;
  max-width: 15rem;
  margin: 0px 8px;
`

type ButtonVariants =
  | 'warnWithBorders'
  | 'warnWithoutBorders'
  | 'errorWithBorders'
  | 'errorWithoutBorders'
const buttonStyles = {
  warnWithoutBorders: css`
    border: none;
    background: transparent;
    color: ${({ theme }) => theme.colors['feedback-notice-0']};
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      background: ${({ theme }) => theme.colors['feedback-notice-1']};
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }
  `,
  warnWithBorders: css`
    background-color: ${({ theme }) => theme.colors['feedback-notice-0']};
    border: ${({ theme }) => `1px solid ${theme.colors['feedback-notice-3']}`};
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      background: ${({ theme }) => theme.colors['feedback-notice-1']};
      color: ${({ theme }) => theme.colors['feedback-notice-3']};
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }
  `,
  errorWithBorders: css`
    background-color: ${({ theme }) => theme.colors['feedback-negative-0']};
    border: ${({ theme }) =>
      `1px solid ${theme.colors['feedback-negative-3']}`};
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      background: ${({ theme }) => theme.colors['feedback-negative-2']};
      color: ${({ theme }) => theme.colors['feedback-negative-3']};
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }
  `,
  errorWithoutBorders: css`
    border: none;
    background: transparent;
    color: ${({ theme }) => theme.colors['feedback-negative-0']};
    cursor: pointer;
    transition: color 0.3s ease;

    &:hover {
      color: ${({ theme }) => theme.colors['feedback-negative-3']};
      background: ${({ theme }) => theme.colors['feedback-negative-2']};
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }
  `,
}

export const StyledButton = styled(Button)<
  Partial<{ variant: ButtonVariants }>
>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: ${({ theme }) => theme.spacing[8]};
  padding-bottom: ${({ theme }) => theme.spacing[8]};
  white-space: nowrap;
  width: 100%;
  ${({ variant = 'warningWithBorders' }) =>
    buttonStyles[variant as ButtonVariants]}
`

export const StyledTextButton = styled.div`
  display: flex;
  white-space: nowrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[8]};
  justify-content: flex-start;
`
